import React from 'react';
import Image from 'next/image';
import styles from '../styles.module.scss';
import { LANDING_PAGE_DATA } from '../config';
import { useViewport } from 'src/common/utils/responsive';

const Index = () => {
  const { customer_support } = LANDING_PAGE_DATA;
  const { isMobile } = useViewport();

  return (
    <section className={styles.customerSupportSection}>
      <div>
        <div
          className={styles.sectionTitle}
          style={{ marginBottom: 'unset', padding: isMobile ? '0 20px' : '' }}
        >
          {customer_support.title}
        </div>
        <div
          className={
            isMobile
              ? styles.customerSupportHighlight
              : styles.customerSupportHighlight
          }
        >
          {customer_support.colored_text}
        </div>
        <div className={styles.customerSupportSubtitle}>
          {customer_support.subtitle}
        </div>
      </div>
      <div className={styles.phoneImageContainer}>
        <Image
          src={customer_support?.image_url}
          height={isMobile ? '300px' : '360px'}
          width={isMobile ? '360px' : '420px'}
        />
      </div>
    </section>
  );
};

export default Index;
